import { ArrowRightCircleIcon } from './ArrowRightCircleIcon';

/**
 * author: Austin Andrews
 * id DF8E13FB-5C26-4C43-A6DC-F01185A97E42
 * name arrow-right-circle
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowForwardCircleIcon = ArrowRightCircleIcon;
export default ArrowForwardCircleIcon